// types
import { IUserInfo } from 'types/session';
import { IProfilePlatforms } from 'types/profiles';

// constants
import {
    PLATFORMS_TO_UBISOFT_PROFILE_PLATFORMS,
} from '../ubisoft-connect-service/constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

// utils
import { getEnumValues } from '@sitegen/bo/shared/utils';

const supportedPlatforms = getEnumValues(PLATFORM_TYPES);

export const prepareProfilePlatforms = (profiles: IUserInfo[], platformSelectionConfig: Array<string>): IProfilePlatforms => {
    return supportedPlatforms
        .filter((platform: PLATFORM_TYPES) => platformSelectionConfig.includes(platform))
        .map((platform: PLATFORM_TYPES) => {
            const profilePlatform = profiles.find((profile) => {
                return profile.platformType === PLATFORMS_TO_UBISOFT_PROFILE_PLATFORMS[platform];
            }) || {};

            return {
                ...profilePlatform,
                id: platform
            };
        });
};
